import { useEffect, useState } from 'react';
import numeral from 'numeral';
import {
  Box,
  Button,
  Card,
  CardActions,
  CardContent,
  CardHeader,
  Divider,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  TableSortLabel,
  Tooltip,
  Typography
} from '@mui/material';
import { InformationCircleOutlined as InformationCircleOutlinedIcon } from '../../../icons/information-circle-outlined';
import { ArrowRight as ArrowRightIcon } from '../../../icons/arrow-right';
import { useRouter } from 'next/router';
import { SentimentSatisfied, SentimentSatisfiedOutlined } from '@mui/icons-material';
import { motivosCancelacion } from '../../../utils/constants';

const applySort = (oportunidadesPerdidas, sortDir) => oportunidadesPerdidas.sort((a, b) => {
  let newOrder = 0;

  if (a.count > b.count) {
    newOrder = -1;
  }

  if (a.count < b.count) {
    newOrder = 1;
  }

  return sortDir === 'asc' ? newOrder : -newOrder;
});

const countries = [
  {
    flag: '/static/icons/us_flag.svg',
    name: 'United States',
    seo: 40,
    visits: 31200
  },
  {
    flag: '/static/icons/uk_flag.svg',
    name: 'United Kingdom',
    seo: 47,
    visits: 12700
  },
  {
    flag: '/static/icons/ru_flag.svg',
    name: 'Russia',
    seo: 65,
    visits: 10360
  },
  {
    flag: '/static/icons/ca_flag.svg',
    name: 'Canada',
    seo: 23,
    visits: 5749
  },
  {
    flag: '/static/icons/de_flag.svg',
    name: 'Germany',
    seo: 45,
    visits: 2932
  },
  {
    flag: '/static/icons/es_flag.svg',
    name: 'Spain',
    seo: 56,
    visits: 200
  }
];

export const OportunidadesPerdidasDesglose = (props) => {
  const { oportunidades = [], date = new Date() } = props;
  const router = useRouter();
  const [oportunidadesPerdidas, setOportunidadesPerdidas] = useState([]);
  const [sort, setSort] = useState('desc');

  const handleSort = () => {
    setSort((prevOrder) => {
      if (prevOrder === 'asc') {
        return 'desc';
      }

      return 'asc';
    });
  };

  const sortedOportunidadesPerdidas = applySort(oportunidadesPerdidas, sort);

  // Rellenar oportunidadesPerdidas con las oportunidades que tengan un status de "cancelled"
  // El objeto debe tener:
  // canceledReason
  // count
  // percentage

  const getOportunidadesPerdidas = () => {
    const oportunidadesPerdidas = [];
    const oportunidadesPerdidasLength = oportunidades.filter(oportunidad => oportunidad.status === 'cancelled').length;

    motivosCancelacion.forEach(motivo => {
      const oportunidadesPerdidasMotivo = oportunidades.filter(oportunidad => oportunidad.canceledReason === motivo.value);
      oportunidadesPerdidas.push({
        name: motivo.label,
        count: oportunidadesPerdidasMotivo.length,
        percentage: (oportunidadesPerdidasMotivo.length / oportunidadesPerdidasLength) * 100
      });
    });

    if (oportunidadesPerdidasLength > 0) {
      setOportunidadesPerdidas(oportunidadesPerdidas);
      console.log(oportunidadesPerdidasLength);
    }
  }

  useEffect(() => {
    getOportunidadesPerdidas();
  }, [oportunidades]);


  return (
    <>
      {
        oportunidadesPerdidas.length > 0 && (
          <Card {...props}>
            <CardHeader
              title="Procesos de venta perdidos"
              action={(
                <Tooltip title="Principales motivos por los que se pierden los procesos de venta">
                  <InformationCircleOutlinedIcon sx={{ color: 'action.active' }} />
                </Tooltip>
              )}
            />
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell>
                    Motivo
                  </TableCell>
                  <TableCell sortDirection={sort}>
                    <TableSortLabel
                      active
                      direction={sort}
                      onClick={handleSort}
                    >
                      Conteo
                    </TableSortLabel>
                  </TableCell>
                  <TableCell>
                    Porcentaje
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {sortedOportunidadesPerdidas.map((oportunidadPerdida) => (
                  <TableRow
                    key={oportunidadPerdida.name}
                    sx={{
                      '&:last-child td': {
                        border: 0
                      }
                    }}
                  >
                    <TableCell>
                      <Typography
                        sx={{ ml: 1 }}
                        variant="subtitle2"
                      >
                        {oportunidadPerdida.name}
                      </Typography>
                    </TableCell>
                    <TableCell>
                      {numeral(oportunidadPerdida.count).format('0,0')}
                    </TableCell>
                    <TableCell>
                      {oportunidadPerdida.percentage.toFixed(2)}
                      %
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
            <Divider />
            <CardActions>
              <Button
                endIcon={(
                  <ArrowRightIcon fontSize="small" />
                )}
                onClick={() => router.push('/dashboard/oportunidades')}
              >
                Ver todo
              </Button>
            </CardActions>
          </Card>
        ) || (
          <Card>
            <CardContent
              sx={{
                alignItems: 'center',
                display: 'flex',
                flexDirection: 'column',
                p: 4
              }}
            >
              <SentimentSatisfiedOutlined
                sx={{
                  color: 'success.main',
                  height: 56,
                  width: 56
                }}
              />
              <Typography
                color="textSecondary"
                variant="h5"
                sx={{ mt: 2 }}
              >
                ¡Excelente!
              </Typography>
              <Typography
                color="textSecondary"
                variant="subtitle2"
              >
                No tienes oportunidades perdidas ¡Sigue así!
              </Typography>
            </CardContent>
          </Card>
        )
      }
    </>
  );
}